import React from "react";
import { Facebook, Twitter, Instagram, Youtube, Linkedin, Heart } from "lucide-react";
import { Link } from "react-router-dom";

const Footer = () => {
  // Only keep working links that exist in your app
  const footerLinks = {
    "Quick Links": [
      { label: "Home", path: "/" },
      { label: "Campaigns", path: "/campaigns" },
      { label: "Start Fundraiser", path: "/start-fundraiser" },
    ],
    "Account": [
      { label: "Sign In", path: "/signin" },
      { label: "Register", path: "/signin" },
    ]
  };

  const socialIcons = [
    { IconComponent: Facebook, label: "Facebook" },
    { IconComponent: Twitter, label: "Twitter" },
    { IconComponent: Instagram, label: "Instagram" },
    { IconComponent: Youtube, label: "YouTube" },
    { IconComponent: Linkedin, label: "LinkedIn" },
  ];

  return (
    <>
      {/* Simple CTA Banner */}
      <div className="bg-teal-600 py-4 px-4">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <div className="text-center sm:text-left">
              <p className="text-white font-medium">
                Start making a difference today
              </p>
            </div>
            <div className="flex gap-3">
              <Link 
                to="/start-fundraiser" 
                className="bg-white text-teal-700 font-medium px-6 py-2 rounded-lg hover:bg-teal-50 transition-colors"
              >
                Start Fundraiser
              </Link>
              <Link 
                to="/campaigns" 
                className="border border-white text-white font-medium px-6 py-2 rounded-lg hover:bg-white/10 transition-colors"
              >
                Donate Now
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Main Footer - Simplified */}
      <footer className="bg-teal-800 py-8">
        <div className="max-w-7xl mx-auto px-4">
          {/* Top Section */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 pb-8">
            {/* Brand Section */}
            <div className="space-y-4">
              <Link to="/" className="inline-block">
                <div className="flex items-center gap-3">
                  <div className="bg-white p-2 rounded-full">
                    <Heart className="w-6 h-6 text-teal-600" />
                  </div>
                  <div>
                    <span className="text-white font-bold text-3xl">
                      DonatePe
                    </span>
                    <p className="text-teal-200 text-sm">
                      Compassionate giving
                    </p>
                  </div>
                </div>
              </Link>
              
              <p className="text-teal-100 text-sm">
                Empowering people to create positive change through secure and transparent giving.
              </p>
            </div>

            {/* Links */}
            <div className="grid grid-cols-2 gap-8">
              {Object.entries(footerLinks).map(([category, links]) => (
                <div key={category} className="space-y-3">
                  <h4 className="font-bold text-white text-base mb-3">
                    {category}
                  </h4>
                  <div className="space-y-2">
                    {links.map((link) => (
                      <Link
                        key={link.path}
                        to={link.path}
                        className="text-teal-200 hover:text-white text-sm transition-colors block"
                      >
                        {link.label}
                      </Link>
                    ))}
                  </div>
                </div>
              ))}
            </div>

            {/* Social Media */}
            <div className="space-y-4">
              <h4 className="font-bold text-white text-base">Connect with us</h4>
              <div className="flex gap-3">
                {socialIcons.map(({ IconComponent, label }) => (
                  <a
                    key={label}
                    href="#"
                    className="flex items-center justify-center w-10 h-10 rounded-full bg-teal-700 text-white hover:bg-teal-600 transition-colors"
                    aria-label={label}
                  >
                    <IconComponent className="w-5 h-5" />
                  </a>
                ))}
              </div>
            </div>
          </div>

          {/* Bottom Bar */}
          <div className="border-t border-teal-700 pt-6">
            <div className="flex flex-col md:flex-row items-center justify-between gap-4">
              <div className="text-center md:text-left">
                <p className="text-teal-300 text-sm">
                  © {new Date().getFullYear()} DonatePe. All rights reserved to BOBROS.
                </p>
                <p className="text-teal-400 text-xs mt-1">
                  A compassionate giving platform
                </p>
              </div>
              
              <div className="flex gap-4">
                <Link to="#" className="text-teal-300 hover:text-white text-sm transition-colors">
                  Privacy
                </Link>
                <Link to="#" className="text-teal-300 hover:text-white text-sm transition-colors">
                  Terms
                </Link>
                <Link to="#" className="text-teal-300 hover:text-white text-sm transition-colors">
                  Contact
                </Link>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;